/**
 * Enum para as etapas do processo de autenticação
 */
export enum AuthStep {
  VALIDATE_DOCUMENT = 'VALIDATE_DOCUMENT',
  SELECT_PHONE = 'SELECT_PHONE',
  VERIFY_PHONE_OTP = 'VERIFY_PHONE_OTP',
  VALIDATE_EMAIL = 'VALIDATE_EMAIL',
  VERIFY_EMAIL_OTP = 'VERIFY_EMAIL_OTP',
  CONFIRM_AUTHENTICATION = 'CONFIRM_AUTHENTICATION',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}

/**
 * Enum para os tipos de OTP
 */
export enum OtpType {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  SMS = 'SMS'
}

/**
 * Interface para erros de API baseada no padrão Axios
 */
export interface ApiError {
  message: string;
  response?: {
    data?: {
      message?: string;
    };
    status?: number;
  };
}
